import { Edit, Printer, Trash2 } from 'lucide-react'
import React from 'react'
import { Link } from 'react-router-dom'

function Table({ records, id, handleEdit, handleDelete }) {
  return (
    <div>
      <table>
        <thead>
          <tr>
            <th>S.NO</th>
            <th>Scanned Code</th>
            <th>Product Section</th>
            <th>Purity</th>
            <th>Product Description</th>
            <th>Gross Wt(g)</th>
            <th>Net Wt(g)</th>
            <th>Depre. Wt(g)</th>
            <th>Net Wt Af. Depre.(g)</th>
            <th>Total Ded. Amt</th>
            <th>Total</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {records && records.length > 0 ? (
            records.map((row, idx) => (
              <tr key={idx}>
                <td>{idx + 1}</td>
                <td>{row.invoiceNo || '-'}</td>
                <td>{row.productSection || '-'}</td>
                <td>{row.purity || '-'}</td>
                <td>{row.productDescription || '-'}</td>
                <td>{row.grossInfo || '-'}</td>
                <td>{row.metalInfo || '-'}</td>
                <td>{row.depreciatedWeight || '-'}</td>
                <td>{isNaN(row.netWtAfDepre)?0 : row.netWtAfDepre|| '-'}</td>
                <td>{row.rateDeductionAmount || '-'}</td>
                <td>{row.total || '-'}</td>
                <td style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
                  {!id && (
                    <>
                      <Edit style={{ cursor: 'pointer' }} onClick={() => handleEdit(idx)} />
                      <Trash2 style={{ cursor: 'pointer' }} onClick={() => handleDelete(idx)} />
                    </>
                  )}
                  {id && (
                    <Link to={row?.pdf} target="_blank">
                      <Printer style={{ cursor: 'pointer' }} />
                    </Link>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="12" style={{ textAlign: "center", padding: "1rem" }}>
                No record found
              </td>
            </tr>
          )}
        </tbody>

      </table>
    </div>
  )
}

export default Table